// src/api/subdomain.ts
import { supabase } from "@cl/supabase";
import { handleSupabaseError } from "./_error";

export interface PublicOwner {
  owner_id: string;
  name: string | null;
  avatar_url: string | null;
  headline: string | null;
  bio: string | null;
  profile_kind: string | null;
  website_url: string | null;
  contact_whatsapp: string | null;
  contact_phone: string | null;
  contact_email: string | null;
  social_instagram: string | null;
  social_linkedin: string | null;
  social_facebook: string | null;
  translations: Record<string, unknown> | null;
}

/** Resolve a vanity slug to its owner (public data only). Null if unknown. */
export async function resolveSubdomain(slug: string): Promise<PublicOwner | null> {
  const { data, error } = await supabase
    .rpc("resolve_subdomain", { p_slug: slug })
    .maybeSingle();
  if (error) handleSupabaseError(error, "resolveSubdomain");
  return (data as PublicOwner | null) ?? null;
}

/** Resolve a public `username` to its owner (path-based hub, all plans). */
export async function resolveUsername(username: string): Promise<PublicOwner | null> {
  const { data, error } = await supabase
    .rpc("resolve_username", { p_username: username })
    .maybeSingle();
  if (error) handleSupabaseError(error, "resolveUsername");
  return (data as PublicOwner | null) ?? null;
}
